const FeedbackTypes = {
	GET_FEEDBACKS: 'GET_FEEDBACKS',
	UPDATE_FEEDBACKS: 'UPDATE_FEEDBACKS',
	SELECT_FEEDBACKS: 'SELECT_FEEDBACKS',
	ADD_REPLY: 'ADD_REPLY',
}

export default FeedbackTypes
